// Webpack Imports
// import * as bootstrap from 'bootstrap';
// Webpack Imports
// Import just what we need

// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';


(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});


	let drawer = document.getElementById('header-menu-drawer');
	let drawerToggleBtn = document.getElementById('drawer-toggle-btn');

	if (drawer != null || drawer != undefined){

		drawer.addEventListener('show.bs.offcanvas', function () {
			drawerToggleBtn.ariaExpanded = true;
		})
		drawer.addEventListener('hide.bs.offcanvas', function () {
			drawerToggleBtn.ariaExpanded = false;
		})
	}


	

	const options = {
		root: null,
		rootMargin: '0px',
		threshold: .4
	}
	const callbacks = (entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('active');
			}
		});
	}
	let observer = new IntersectionObserver(callbacks, options);
	
	const animateElements = document.querySelectorAll('.animate');
	
	
	
	animateElements.forEach(element => {
		observer.observe(element);
	});

})();



